module.exports = __webpack_public_path__ + "twitter-icon-small-6159d5f0c669daf994beb0301edc49c3.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/social-medias/twitter-icon-small.svg
// module id = 97
// module chunks = 0